export enum BalanceBlockStatus {
	ACTIVE = 'ACTIVE',
	BLOCKING = 'BLOCKING',
	UNBLOCKING = 'UNBLOCKING',
	REMOVED = 'REMOVED',
}
